import { tourTypeCrudConfig } from '@/config/objects/tour-types';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';

/**
 * Tour Types list page
 */
export function TourTypesPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Tour Types', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView config={tourTypeCrudConfig} baseUrl="/tour-types" breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
